import { CommonModule } from '@angular/common';
import {
  Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, OnChanges, SimpleChanges, OnInit
} from '@angular/core';

import { isEmpty } from '@app/util/util';
import { ImageSize, ImageWidthOrHeight } from '@design-system/components/molecules/image/entities/image.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { BorderRadiusDsType } from '@design-system/entities/border-radius.type';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    LoaderRingDsComponent,
  ]
})
export class ImageDsComponent implements OnChanges, OnInit {

  @Input() size = ImageSize.RG;
  @Input() alt = '';
  @Input() src: string;
  @Input() srcSet: string;
  @Input() srcFallback: string;
  @Input() height: ImageWidthOrHeight = null;
  @Input() width: ImageWidthOrHeight = null;
  @Input() objectFit = null;
  @Input() borderRadius: BorderRadiusDsType = null;
  @Input() useLoader = false;

  @Output() errorEvent: EventEmitter<void> = new EventEmitter<void>();

  public imgSrc = '';
  public unsuccessfulReplacement = false;
  public imgIsLoaded = false;

  public readonly imageNotAvailable = Icon.ImageNotAvailable;
  public readonly iconFillColor = IconFillColor;

  constructor(
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.imgIsLoaded = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.src) {
      this.imgSrc = changes.src.currentValue;
      this.unsuccessfulReplacement = false;
    }
    this.cdr.detectChanges();
  }

  get widthImage(): string {
    return this.size === ImageSize.None ? this.width : null;
  }

  get heightImage(): string {
    return this.size === ImageSize.None ? this.height : null;
  }

  get iconSize(): number {
    switch (this.size) {
      case ImageSize.LG:
        return 35;
      case ImageSize.RG:
        return 25;
      case ImageSize.MD:
        return 18;
      case ImageSize.SM:
        return 10;
      default:
        const widthNumber = this.widthImage?.replace(/[^0-9]/g, '');
        if (!isEmpty(widthNumber)) {
          return Number(widthNumber) / 2;
        } else {
          return 100;
        }
    }
  }

  public errorHandler(): void {
    this.imgSrc = this.srcFallback;
    this.unsuccessfulReplacement = isEmpty(this.srcFallback);
    this.imgIsLoaded = this.unsuccessfulReplacement;
    this.errorEvent.emit();
    this.cdr.detectChanges();
  }

  public loadHandler(): void {
    this.imgIsLoaded = true;
    this.cdr.detectChanges();
  }

}
